export const PARAMS_KEY_CHART_ID = 'chartId';
export const PARAMS_KEY_REPORT_ID = 'reportId';
export const PARAMS_KEY_SUBPRODUCT = 'subproduct';
export const PARAMS_KEY_PAGE_KEY = 'pageKey';
export const PARAMS_KEY_SPEND_GROUP = 'spendGroup';
export const PARAMS_KEY_SPEND_CHART = 'spendChart';
export const PARAMS_KEY_SEGMENT = 'segment';
/** Which sidebar list opened the current report: favorites vs defaults (analytics). */
export const PARAMS_KEY_REPORT_SIDEBAR_SECTION = 'reportSidebarSection';
export const REPORT_SIDEBAR_SECTION_FAVORITES = 'favorites';
/** Shared workspace sidebar reports (pinned defaults). */
export const REPORT_SIDEBAR_SECTION_DEFAULTS = 'defaults';
/** Personal private sidebar pinned reports (`/default-reports` + `is_private`). */
export const REPORT_SIDEBAR_SECTION_PRIVATE = 'private';
export const PARAMS_KEY_FOCUSED_CHART_ID = 'focusedChartId';
export const PARAMS_KEY_EXPLORE_KEY = 'exploreKey';
/** Opaque token correlating browser history with report-table pagination restore state in sessionStorage. Used when drilling down */
export const PARAMS_KEY_TABLE_RETURN = 'tableReturn';
export const PARAMS_KEY_PROJECT_ID = 'projectId';
export const PARAMS_KEY_ORGANIZATION_ID = 'organizationId';
export const PARAMS_KEY_SELECTED_PROJECT_ID = 'projectsProjectId';
export const PARAMS_KEY_HOME_TAB = 'homeTab';
export const PARAMS_KEY_REPORT_TYPE = 'reportType';
export const PARAMS_KEY_REPORT_SHARED_TIME_RANGE = 'reportSharedTimeRange';
export const PARAMS_KEY_PAGE_TIME_RANGE = 'pageTimeRange';
export const PARAMS_KEY_PAGE_FILTERS = 'pageFilters';
export const PARAMS_KEY_REPORT_SEARCH = 'reportSearch';
export const PARAMS_KEY_REPORT_SORT_BY = 'reportSortBy';
export const PARAMS_KEY_SORT_BY = 'sortBy';
export const PARAMS_KEY_SORT_ORDER = 'sortOrder';
export const PARAMS_KEY_PAGE = 'page';
export const PARAMS_KEY_TIME_RANGE = 'timeRange';
export const PARAMS_KEY_WARNINGS_GROUP_BY = 'warningsGroupBy';
export const PARAMS_KEY_AB_TESTING_TIME_RANGE = 'abTestingTimeRange';
export const PARAMS_KEY_CUSTOM_CATEGORIES = 'customCategories';
export const PARAMS_KEY_INTENTS_TABLE_GROUPBY = 'intentsTableGroupBy';
export const PARAMS_KEY_AGGREGATE_BY = 'globalAggregateBy';
export const PARAMS_KEY_GROUP_BY = 'groupBy';
export const PARAMS_KEY_SEARCH = 'search';
export const PARAMS_KEY_BREADCRUMB_TITLE = 'breadcrumbTitle';
export const PARAMS_KEY_DRAWER_IDX = 'drawerIdx';
export const PARAMS_KEY_SETTINGS_TAB = 'settingsTab';
export const PARAMS_KEY_INTERACTION_SEARCH = 'interactionSearch';
export const PARAMS_KEY_INTERACTION_GROUP_BY = 'interactionGroupBy';
export const PARAMS_KEY_INTERACTION_HIGHLIGHTED_ROW = 'interactionHighlightedRow';
export const PARAMS_KEY_TAGS_DETAILS_TOPIC_TAB = 'tagsDetailsTopicTab';
export const PARAMS_KEY_USER_INTENTS_PAGE_SORT_BY = 'userIntentsPageSortBy';
export const PARAMS_KEY_USER_INTELL_RISKY_BEHAVIORS_SORT_BY = 'userIntelligenceRiskyBehaviorsSortBy';
export const PARAMS_KEY_USER_INTENTS_VERTICAL_TAB_STRING = 'userIntentsVerticalTabString';
export const PARAMS_KEY_USER_INTENTS_VERTICAL_TAB = 'userIntentsVerticalTab';
export const PARAMS_KEY_LLM_PROBLEMS_VERTICAL_TAB = 'llmProblemsVerticalTab';
export const PARAMS_KEY_USER_INTENTS_PAGE_SEARCH = 'userIntentsPageSearch';
export const PARAMS_KEY_TOPICS_DETAILS_TAB = 'topicsDetailsTab';
export const PARAMS_KEY_USER_INTELL_PAGE_SEARCH = 'userIntelligencePageSearch';
export const PARAMS_KEY_USER_INTELL_PAGE_SORT_BY = 'userIntelligencePageSortBy';
export const PARAMS_KEY_USER_INTELL_PAGE_PRIMARY_METRIC = 'userIntelligencePagePrimaryMetric';
export const PARAMS_KEY_USER_INTELL_PAGE_SECONDARY_METRIC = 'userIntelligencePageSecondaryMetric';
export const PARAMS_KEY_LLM_REDIRECT_FROM_REPORTS = 'llmRedirectFromReports';
export const PARAMS_KEY_INTERACTIONS_REDIRECT_FROM_REPORTS = 'interactionsRedirectFromReports';
export const PARAMS_KEY_SORT_BY_PROJECTS_PAGE = 'sortByProjectsPage';
export const PARAMS_KEY_SORT_BY_SETTINGS_PROJECTS_PAGE = 'sortByProjectsPage';
export const PARAMS_KEY_SORT_BY_PROJECTS_PAGE_SEARCH = 'sortByProjectsPageSearch';
export const PARAMS_KEY_SORT_BY_ORGANIZATIONS_PAGE = 'sortByOrganizationsPage';
export const PARAMS_KEY_SORT_BY_SETTING_REPORTS_PAGE = 'sortBySettingReportsPage';
export const PARAMS_KEY_SORT_BY_ORGANIZATIONS_PAGE_SEARCH = 'sortByOrganizationsPageSearch';
export const PARAMS_KEY_INTENT_SUBPAGE = 'intentSubpage';
export const PARAMS_KEY_USER_INTELLIGENCE_CREATED_TOPIC = 'userIntelligenceCreatedTopic';
export const PARAMS_KEY_USER_INTELLIGENCE_VIEW = 'userIntelligenceView';
export const PARAMS_KEY_USERS_INTERACTIONS_VIEW = 'usersInteractionsView';
export const PARAMS_KEY_USER_INTELLIGENCE_DETAILS_VIEW = 'userIntelligenceDetailsView';
export const PARAMS_KEY_REFERRAL = 'referral';
export const PARAMS_KEY_PENETRATION_VARIABLE = 'penetrationVariable';
export const PARAMS_USER_INTELLIGENCE_MAIN_SEARCH = 'user-intelligence-main-search';
export const PARAMS_KEY_SETTINGS_PAGE_TAB = 'settingsPageTab';
/** Settings → Members tab: search query for name/email. */
export const PARAMS_KEY_SETTINGS_MEMBERS_SEARCH = 'settingsMembersSearch';
/** Settings → Members tab: role filter slug or `all`. */
export const PARAMS_KEY_SETTINGS_MEMBERS_ROLE = 'settingsMembersRole';
export const PARAMS_KEY_SETTINGS_REPORTS_TABLE_TAB = 'settingsReportsTableTab';
/** Tab on `/all-reports`: `my-reports` | `all`. */
export const PARAMS_KEY_ALL_REPORTS_TAB = 'allReportsTab';
/** Optional section filter on `/all-reports` from sidebar section edit: `favorites` | `private` | `workspace`. */
export const PARAMS_KEY_ALL_REPORTS_SCOPE = 'allReportsScope';
export const ALL_REPORTS_SCOPE_FAVORITES = 'favorites';
export const ALL_REPORTS_SCOPE_PRIVATE = 'private';
export const ALL_REPORTS_SCOPE_WORKSPACE = 'workspace';
export const PARAMS_KEY_LIVE_ACTIVITY_PAGE_TAB = 'liveActivityPageTab';
export const PARAMS_KEY_KEEP_URL_TIMERANGE = 'keepUrlTimerange';
export const PARAMS_KEY_EXPERIMENT_SUBPAGE = 'experiment-subpage';
export const PARAMS_KEY_USER_PROBLEMS_TAB = 'userProblemsTab';
export const PARAMS_KEY_OUT_OF_SCOPE_TAB = 'outOfScopeTab';
export const PARAMS_KEY_USER_PROBLEMS_CHART_VIEW = 'userProblemsChartView';
export const PARAMS_KEY_OUT_OF_SCOPE_CHART_VIEW = 'outOfScopeChartView';
export const PARAMS_KEY_USER_INTENTS_RISKY_BEHAVIORS_TAB = 'userIntentsRiskyBehaviorsTab';
export const PARAMS_KEY_USER_INTENTS_RISKY_BEHAVIORS_SEARCH = 'userIntentsRiskyBehaviorsSearch';
export const PARAMS_KEY_USER_INTELLIGENCE_TAGS_SELECTED_TOPIC = 'userIntelligenceTagsSelectedTopic';
export const PARAMS_KEY_USER_INTELLIGENCE_TAGS_SEARCH = 'userIntelligenceTagsSearch';
export const PARAMS_KEY_WARNING_PAGE_DATA = 'warningPageData';
export const PARAMS_KEY_OUT_OF_SCOPE_PAGE_DATA = 'outOfScopePageData';
export const PARAMS_KEY_OUT_OF_SCOPE_REDIRECT_FROM_REPORTS = 'outOfScopeRedirectFromReports';
export const PARAMS_KEY_SETTINGS_PAGE_INTERACTIONS_ACCESS_DATA = 'settingsPageInteractionsAccessData';

// ALL FILTER KEYS
export const PARAMS_KEY_REPORT_SHARED_FILTERS = 'reportSharedFilters';
export const PARAMS_KEY_LLM_FILTERS = 'llmFilters';
export const PARAMS_KEY_LLM_DETAILS_FILTERS = 'llmDetailsFilters';
export const PARAMS_KEY_GLOBAL_FILTERS = 'globalFilters';
export const PARAMS_KEY_USERS_FILTERS = 'usersFilters';
export const PARAMS_KEY_LLM_PROBLEMS_PROBLEM_FILTERS = 'llmProblemsProblemFilters';
export const PARAMS_KEY_USER_INTENTS_FILTERS = 'userIntentsFilters';
export const PARAMS_KEY_INTERACTION_FILTERS = 'interactionFilters';
export const PARAMS_KEY_CONVERSATIONS_FILTERS = 'conversationsFilters';
export const PARAMS_KEY_INTERACTION_SHARED_FILTERS = 'interactionSharedFilters';
export const PARAMS_KEY_USER_INTELLIGENCE_FILTERS = 'userIntelligenceFilters';
export const PARAMS_KEY_USER_INTENTS_RISKY_BEHAVIORS_FILTERS = 'userIntentsRiskyBehaviorsFilters';
export const PARAMS_KEY_OUT_OF_SCOPE_FILTERS = 'outOfScopeFilters';
export const PARAMS_COMPARED_KEY_FILTERS = 'comparedFilters';
export const PARAMS_COMPARED_PROJECT_ID = 'comparedProjectId';
export const PARAMS_COMPARED_TIME_RANGE = 'comparedTimeRange';

export const ALL_LOCAL_FILTERS_KEYS = [
  PARAMS_KEY_REPORT_SHARED_FILTERS,
  PARAMS_KEY_LLM_FILTERS,
  PARAMS_KEY_LLM_DETAILS_FILTERS,
  PARAMS_KEY_GLOBAL_FILTERS,
  PARAMS_KEY_USERS_FILTERS,
  PARAMS_KEY_LLM_PROBLEMS_PROBLEM_FILTERS,
  PARAMS_KEY_INTERACTION_FILTERS,
  PARAMS_KEY_USER_INTELLIGENCE_FILTERS,
  PARAMS_KEY_USER_INTENTS_RISKY_BEHAVIORS_FILTERS,
  PARAMS_KEY_OUT_OF_SCOPE_FILTERS,
  PARAMS_COMPARED_KEY_FILTERS,
];

export const SHARED_FILTERS_MAP = {
  PARAMS_KEY_INTERACTION_SHARED_FILTERS: [PARAMS_KEY_INTERACTION_FILTERS],
  PARAMS_KEY_LLM_PROBLEMS_PROBLEM_FILTERS: [PARAMS_KEY_LLM_FILTERS],
};

/** Deep-link param: filter the interactions page to a specific conversation */
export const PARAMS_KEY_CONVERSATION_ID = 'conversationId';
/** Deep-link param: open the detail sidebar for a specific interaction */
export const PARAMS_KEY_INTERACTION_ID = 'interactionId';
